import { CHAINS_INFO_MAP } from '@dynamic-labs-sdk/client/core';

export const evmApiChainName = CHAINS_INFO_MAP.EVM.apiChainName;

/**
 * List of methods that may be requested from EVM wallet applications.
 *
 * Source: https://github.com/WalletConnect/walletconnect-monorepo/blob/v2.0/providers/ethereum-provider/src/EthereumProvider.ts
 */
export const evmMethods = [
  'personal_sign',
  'eth_sendTransaction',
  'eth_accounts',
  'eth_requestAccounts',
  'eth_call',
  'eth_getBalance',
  'eth_sendRawTransaction',
  'eth_sign',
  'eth_signTransaction',
  'eth_signTypedData',
  // eslint-disable-next-line custom-rules/ban-ethereum-eth-terms
  'eth_signTypedData_v3',
  // eslint-disable-next-line custom-rules/ban-ethereum-eth-terms
  'eth_signTypedData_v4',
  'wallet_switchEthereumChain',
  'wallet_addEthereumChain',
  'wallet_getPermissions',
  'wallet_requestPermissions',
  'wallet_registerOnboarding',
  'wallet_watchAsset',
  'wallet_scanQRCode',
  'wallet_sendCalls',
  'wallet_getCapabilities',
  'wallet_getCallsStatus',
  'wallet_showCallsStatus',
] as const;
